import {AssetMetadata} from '@contentlab/types/asset';

export const getResolutionFromMetadata = (metadata: AssetMetadata): string => {
  return getResoultionDisplayValue(Math.min(metadata.height, metadata.width));
};

export const getResoultionDisplayValue = (resolution: number): string => {
  if (resolution === 2160) return '4K - 2160p';
  if (resolution === 1440) return '2K - 1440p';
  if (resolution === 1080) return 'Full HD - 1080p';
  if (resolution === 720) return 'HD - 720p';
  return `${resolution}p`;
};
